import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Button,
  FormControl,
  Input,
  FormLabel,
  HStack,
  Text,
  Select,
  Switch,
  useToast,
  filter,
  Checkbox,
  VStack,
} from "@chakra-ui/react";

import React, { useEffect, useState } from "react";
import ReactSelect from "react-select";
import CrmDataService from "../../services/data";
import { genderOptions } from "../../Config/filter";
import { DateTime } from "luxon";

export const FilterCustomerModal = ({
  isOpen,
  onClose,
  func,
  pageId,
  filters,
  setFilters,
}: any) => {
  const token = localStorage.getItem("logged_in_user_token");
  const initialRef = React.useRef(null);
  const accessControls =
    JSON.parse(localStorage.getItem("logged_in_user_accesscontrols") || "[]") ||
    [];
  const toast = useToast();

  const [experts, setExperts] = useState([]);

  const ageOptions = ["17-24", "25-30", "31-35", "35-45", "45+"];

  const owners = [
    { name: "User1", id: "expert4_tamannarajpal" },
    { name: "User2", id: "expert_mahi" },
    { name: "User3", id: "expert_divanshi" },
    { name: "User4", id: "expert_navyav" },
    { name: "Prakriti", id: "expert_prakriti" },
    { name: "Jigyasa", id: "expert_jigyasa" },
    { name: "Tania", id: "expert_tania" },
  ];

  const fetchExperts = async () => {
    const res = await CrmDataService.getExperts();
    setExperts(res.data);
  };

  const expertOptions = experts?.map((el: any) => ({
    value: el._id,
    label: el.data.full_name,
  }));

  const handleSubmit = () => {
    if (
      (filters.latest_session_date.startDate &&
        !filters.latest_session_date.endDate) ||
      (!filters.latest_session_date.startDate &&
        filters.latest_session_date.endDate)
    ) {
      toast({
        position: "top",
        title: "Session Date Range Error",
        description: "Kindly select both start and end dates for session date.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    if (
      (filters.latest_booking_date.startDate &&
        !filters.latest_booking_date.endDate) ||
      (!filters.latest_booking_date.startDate &&
        filters.latest_booking_date.endDate)
    ) {
      toast({
        position: "top",
        title: "Purchase Date Range Error",
        description:
          "Kindly select both start and end dates for purchase date.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    if (
      (filters.last_followup_date.startDate &&
        !filters.last_followup_date.endDate) ||
      (!filters.last_followup_date.startDate &&
        filters.last_followup_date.endDate)
    ) {
      toast({
        position: "top",
        title: "Followup Date Range Error",
        description:
          "Kindly select both start and end dates for followup date.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    func();
    onClose();
  };

  useEffect(() => {
    fetchExperts();
  }, []);

  useEffect(() => {
    setFilters({ ...filters, sessions_left: "" });
  }, [pageId]);

  // console.log(filters);

  return (
    <>
      <Modal
        initialFocusRef={initialRef}
        isOpen={isOpen}
        onClose={onClose}
        size="lg"
        scrollBehavior="inside"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Filters</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6} maxH="500px" overflowY="auto">
            <Checkbox
              mb={6}
              isChecked={filters.hide_future_sessions}
              onChange={(e) =>
                setFilters({
                  ...filters,
                  hide_future_sessions: e.target.checked,
                })
              }
            >
              Hide Future Sessions
            </Checkbox>
            <HStack align="start" justify="space-between" w="100%">
              <Checkbox
                mb={6}
                isChecked={filters.valid_treatment_plan}
                onChange={(e) =>
                  setFilters({
                    ...filters,
                    valid_treatment_plan: e.target.checked,
                  })
                }
              >
                Treatment Plan Available
              </Checkbox>
              <Checkbox
                mb={6}
                isChecked={filters.valid_session_plan}
                onChange={(e) =>
                  setFilters({
                    ...filters,
                    valid_session_plan: e.target.checked,
                  })
                }
              >
                Session Plan Available
              </Checkbox>
            </HStack>
            {/* <HStack align="start" justify="space-between" w="100%"> */}
            {/* <VStack w={300}> */}
            <FormControl mb={6}>
              <FormLabel>Session Date</FormLabel>
              <HStack spacing={10} ml={10}>
                <VStack align="start" mb={0} spacing={0}>
                  <FormLabel fontWeight="normal">From</FormLabel>
                  <Input
                    type="date"
                    value={filters.latest_session_date.startDate}
                    onChange={(e) => {
                      setFilters({
                        ...filters,
                        latest_session_date: {
                          ...filters.latest_session_date,
                          startDate: e.target.value,
                        },
                      });
                    }}
                  />
                </VStack>
                <VStack align="start" mb={0} spacing={0}>
                  <FormLabel fontWeight="normal">To</FormLabel>
                  <Input
                    type="date"
                    value={filters.latest_session_date.endDate}
                    onChange={(e) => {
                      setFilters({
                        ...filters,
                        latest_session_date: {
                          ...filters.latest_session_date,
                          endDate: e.target.value,
                        },
                      });
                    }}
                  />
                </VStack>
              </HStack>
            </FormControl>

            <FormControl mb={6}>
              <FormLabel>Type</FormLabel>
              <Select
                value={filters.type}
                onChange={(e) =>
                  setFilters({ ...filters, type: e.target.value })
                }
              >
                <option value="">All</option>
                <option value="assigned">Assigned</option>
                <option value="marked">Marked</option>
              </Select>
            </FormControl>

            <FormControl mb={6}>
              <FormLabel>Purchase Date</FormLabel>
              <HStack spacing={10} ml={10}>
                <VStack align="start" mb={0} spacing={0}>
                  <FormLabel fontWeight="normal">From</FormLabel>
                  <Input
                    type="date"
                    value={filters.latest_booking_date.startDate}
                    onChange={(e) => {
                      setFilters({
                        ...filters,
                        latest_booking_date: {
                          ...filters.latest_booking_date,
                          startDate: e.target.value,
                        },
                      });
                    }}
                  />
                </VStack>
                <VStack align="start" mb={0} spacing={0}>
                  <FormLabel fontWeight="normal">To</FormLabel>
                  <Input
                    type="date"
                    value={filters.latest_booking_date.endDate}
                    onChange={(e) => {
                      setFilters({
                        ...filters,
                        latest_booking_date: {
                          ...filters.latest_booking_date,
                          endDate: e.target.value,
                        },
                      });
                    }}
                  />
                </VStack>
              </HStack>
            </FormControl>

            <FormControl mb={6}>
              <FormLabel>Followup Date</FormLabel>
              <HStack spacing={10} ml={10}>
                <VStack align="start" mb={0} spacing={0}>
                  <FormLabel fontWeight="normal">From</FormLabel>
                  <Input
                    type="date"
                    value={filters.last_followup_date.startDate}
                    onChange={(e) => {
                      setFilters({
                        ...filters,
                        last_followup_date: {
                          ...filters.last_followup_date,
                          startDate: e.target.value,
                        },
                      });
                    }}
                  />
                </VStack>
                <VStack align="start" mb={0} spacing={0}>
                  <FormLabel fontWeight="normal">To</FormLabel>
                  <Input
                    type="date"
                    value={filters.last_followup_date.endDate}
                    onChange={(e) => {
                      setFilters({
                        ...filters,
                        last_followup_date: {
                          ...filters.last_followup_date,
                          endDate: e.target.value,
                        },
                      });
                    }}
                  />
                </VStack>
              </HStack>
            </FormControl>

            <FormControl mb={6}>
              <FormLabel>Type</FormLabel>
              <Select
                value={filters.type}
                onChange={(e) =>
                  setFilters({ ...filters, type: e.target.value })
                }
              >
                <option value="">All</option>
                <option value="assigned">Assigned</option>
                <option value="marked">Marked</option>
              </Select>
            </FormControl>

            {filters.type === "assigned" && (
              <FormControl mb={6}>
                <FormLabel>Assigned For</FormLabel>
                <Input
                  value={filters.assigned_for}
                  type="date"
                  onChange={(e) => {
                    setFilters({
                      ...filters,
                      assigned_for: e.target.value,
                    });
                  }}
                />
              </FormControl>
            )}

            {accessControls.includes("salesAdmin") && (
              <FormControl mb={6}>
                <FormLabel>Owner</FormLabel>
                <Select
                  placeholder="Select Owner"
                  value={filters.assigned_expert}
                  onChange={(e) => {
                    setFilters({
                      ...filters,
                      assigned_expert: e.target.value,
                    });
                  }}
                >
                  {owners.map((el) => (
                    <option key={el.id} value={el.id}>
                      {el.name}
                    </option>
                  ))}
                </Select>
              </FormControl>
            )}

            <FormControl mb={4}>
              <FormLabel>Age</FormLabel>
              <Select
                placeholder="Select Age"
                value={filters.age}
                onChange={(e) => {
                  setFilters({ ...filters, age: e.target.value });
                }}
              >
                {ageOptions.map((el) => (
                  <option key={el} value={el}>
                    {el}
                  </option>
                ))}
              </Select>
            </FormControl>
            <HStack align="start" justify="space-between" w="100%">
              <FormControl mb={0}>
                <FormLabel>Expert</FormLabel>
                <ReactSelect
                  id="expert"
                  name="expert"
                  options={expertOptions}
                  placeholder="Choose Expert"
                  isClearable
                  value={
                    expertOptions.find(
                      (option) => option.value === filters.expert,
                    ) || null
                  }
                  onChange={(option) =>
                    setFilters({
                      ...filters,
                      expert: option ? option.value : "",
                    })
                  }
                  classNamePrefix="react-select"
                />
              </FormControl>
              {pageId === "subscription" && (
                <FormControl mb={0}>
                  <FormLabel>Session Left</FormLabel>
                  <Input
                    value={filters.sessions_left}
                    onChange={(e) => {
                      setFilters({ ...filters, sessions_left: e.target.value });
                    }}
                  />
                </FormControl>
              )}
            </HStack>

            {/* <FormControl mb={6}>
              <FormLabel>Gender</FormLabel>
              <Select
                placeholder="Select Gender"
                value={filters.gender}
                onChange={(e) => {
                  setFilters({ ...filters, gender: e.target.value });
                }}
              >
                {genderOptions.map((el) => (
                  <option key={el.value} value={el.value}>
                    {el.label}
                  </option>
                ))}
              </Select>
            </FormControl> */}
            {/* </VStack> */}
            {/* <VStack> */}

            {/* </VStack> */}
            {/* </HStack> */}
          </ModalBody>

          <ModalFooter mt={0} justifyContent="space-between">
            <Button
              bgColor="#f48a0f"
              mr={10}
              color={"white"}
              onClick={() => {
                setFilters({
                  assigned_expert: "",
                  expert: "",
                  sessions_left: "",
                  gender: "",
                  age: "",
                  latest_session_date: { startDate: "", endDate: "" },
                  latest_booking_date: { startDate: "", endDate: "" },
                  last_followup_date: { startDate: "", endDate: "" },
                  type: "",
                  assigned_for: "",
                  hide_future_sessions: false,
                  valid_treatment_plan: false,
                  valid_session_plan: false,
                });
                // func();
                // onClose();
              }}
            >
              Clear Filters
            </Button>
            <HStack gap={4}>
              <Button bgColor="#327171" color={"white"} onClick={handleSubmit}>
                Submit
              </Button>
              <Button bgColor={"red"} color={"white"} onClick={onClose}>
                Cancel
              </Button>
            </HStack>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
